import {Component, OnInit} from '@angular/core';
import {ContractObjectBaseComponent} from "../contract-object-base.component";


@Component({
    selector: 'cm-contract-object-full-component',
    templateUrl: 'contract-object-full.component.html',
    standalone: false
})
export class ContractObjectFullComponent extends ContractObjectBaseComponent implements OnInit {


    ngOnInit() {
        super.ngOnInit();
    }

}
